import React from 'react';

/**
 * Offizielle Social-Media-Profile von Radsport Events.
 * Zentral gepflegt, damit alle Stellen (SocialPromoBanner, die schwebenden Knöpfe) dieselben
 * Ziel-URLs verwenden.
 */
export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/radsport_events/',
  facebook: 'https://www.facebook.com/radsportevents.de',
} as const;

/** Instagram-Outline-Glyph (currentColor). */
export const InstagramGlyph: React.FC<{ size?: number; strokeWidth?: number }> = ({ size = 16, strokeWidth = 1.9 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={strokeWidth} aria-hidden="true">
    <rect x="2.5" y="2.5" width="19" height="19" rx="5" />
    <circle cx="12" cy="12" r="4.2" />
    <circle cx="17.5" cy="6.5" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);

/** Facebook-„f"-Glyph (currentColor). */
export const FacebookGlyph: React.FC<{ size?: number }> = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M14 8.5V6.9c0-.7.2-1.1 1.2-1.1H16.5V3.1C16.1 3 15.2 3 14.3 3c-2 0-3.4 1.2-3.4 3.5v2H8.5V11.4h2.4V21h3.1v-9.6h2.3l.4-2.9H14z" />
  </svg>
);
